import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import { Identifiable, Project } from "@planzone/dto";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  editProjectWeatherReport(
    request: Boundaries["editProjectWeatherReport"]["request"],
  ): void;
}

function useEditProjectWeatherReport(
  project: Identifiable<Project>,
): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(() =>
      selector.isEditProjectWeatherReportRequestPending(project),
    ),
    isRequestSuccess: useSelector(() =>
      selector.isEditProjectWeatherReportRequestSuccess(project),
    ),
    isRequestFailure: useSelector(() =>
      selector.isEditProjectWeatherReportRequestFailure(project),
    ),
    editProjectWeatherReport: core.editProjectWeatherReport,
  };
}

export { useEditProjectWeatherReport };
